import axios from '../../helpers/axios';

export const deletedOrder = (id) => axios.delete(`/order/delete/${id}`);
const urls = {
  status: '/order/update',
  amount: '/order/updateOrderTotalAmount',
  discount: '/order/updateOrderDiscountedTotalAmount',
  visibility: '/order/updateOrderVisibleAdmin',
  item: '/order/updateOrderAdditionalField',
  addItems: '/order/addOrderProductsById',
  deleteItem: '/order/deleteOrderProduct',
  updateField: '/order/updateOrderAdditionalById',
  deleteField: '/order/deleteOrderAdditionalById',
  delivery: '/order/updateOrderDeliveryPickupPointsPayment',
};
export const orderApi = {
  list: (params) => axios.get('/orders', { params }).then(({ data }) => data),
  filters: () => axios.get('/admin/order-filters').then(({ data }) => data),
  detail: (id) => axios.get(`/order/getOrderById/${id}`).then(({ data }) => data.orderDetails),
  command: (type, payload) => {
    if (!urls[type]) return Promise.reject(new Error('Неизвестное действие заказа'));
    return axios.post(urls[type], payload).then(({ data }) => data);
  },
  remove: (id) => deletedOrder(id).then(({ data }) => data),
};
export const orderError = (error) => error?.response?.data?.error || error?.response?.data?.message || error?.message || 'Не удалось выполнить действие';
